export class Permission {
    list?: string[];
    edit?: string[];
    manage?: string[];

    constructor(source?: any) {
        if (source) {
            this.list = source.list;
            this.edit = source.edit;
            this.manage = source.manage;
        }
    }
}
